import React from "react";
import HomeIcon from "@mui/icons-material/Home";


const Navbar = ({ onNavigate, onHomeClick }) => {
    const handleClick = (e, page) => {
        e.preventDefault();     // Prevent full page reload
        onNavigate(page);       // Trigger React state change
    };

    return (
        <nav className="navbar">
            <img src="logo.svg" alt="Logo" className="logo nav-icon" />
            <label htmlFor="menu-toggle" className="menu-icon">&#9776;</label>
            <input type="checkbox" id="menu-toggle" />
            <div className="menu">
            <a
            href="/"
            onClick={(e) => {
                e.preventDefault();
                onNavigate("form");
                if (onHomeClick) onHomeClick();
            }}
            style={{ marginLeft: "20px", display: "flex", alignItems: "center", gap: "4px", color: "white" }}
            >
            <HomeIcon sx={{ fontSize: 23, verticalAlign: "middle" }} />
            </a>
                <a href="/history" onClick={(e) => handleClick(e, "history")}>History</a>
                <a href="/icons" onClick={(e) => handleClick(e, "icons")}>Icons</a>
            </div>
        </nav>
    );
};

export default Navbar;
